import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

// Automatic — records source/medium/campaign/term/content (docs/01-PRODUCT-SPEC.md §3.2).
const configSchema = z.object({});

export const utmCaptureField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "utm_capture",
  label: "Campaign source (UTM)",
  category: "system",
  icon: "Megaphone",
  configSchema,
  valueSchema: (_config, isRequired) =>
    optionalUnlessRequired(
      z
        .object({
          source: z.string().max(200).optional(),
          medium: z.string().max(200).optional(),
          campaign: z.string().max(200).optional(),
          term: z.string().max(200).optional(),
          content: z.string().max(200).optional(),
        })
        .strict(),
      isRequired,
    ),
  defaultConfig: {},
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isHiddenFromApplicant: true },
};
